var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDownYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8672 7.21433L15.0865 14.0624C15.1805 14.2158 15.1715 14.4122 15.0605 14.5558C14.5594 15.2064 14.0514 15.7877 13.6244 16.1755C13.6244 16.1755 13.2824 16.5096 13.0654 16.6542C12.7693 16.8877 12.3823 17 12.0063 17C11.5843 17 11.1853 16.8769 10.8662 16.6317C10.8092 16.576 10.5582 16.364 10.3532 16.1638C9.07715 14.9954 6.96905 11.9455 6.33002 10.3414C6.22701 10.1079 6.012 9.48466 6 9.16131C6 8.84967 6.068 8.54879 6.21701 8.25962C6.42202 7.90403 6.74004 7.62561 7.11706 7.46931C7.37907 7.36869 8.16511 7.21336 8.18811 7.21336C8.74914 7.11274 9.53718 7.03751 10.4572 7.00039C10.6222 6.99355 10.7822 7.07659 10.8672 7.21433Z",
    fill: "#E5B910"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M13.1395 7.67154C12.9525 7.36968 13.1915 6.98966 13.5505 7.00432C14.3925 7.04046 15.1346 7.10298 15.6866 7.17918C15.6986 7.19091 16.6777 7.34623 17.0087 7.52501C17.6237 7.83664 17.9997 8.44818 17.9997 9.10564V9.16035C17.9887 9.58433 17.6127 10.486 17.5897 10.486C17.4007 10.9403 17.0807 11.5333 16.6957 12.1712C16.5216 12.4584 16.0946 12.4652 15.9176 12.178L13.1395 7.67154Z",
    fill: "#E5B910"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownYellow);
export default __webpack_public_path__ + "static/media/arrow-down-Yellow.a7d30b3e95b57b7fb2b0b12130f9c63c.svg";
export { ForwardRef as ReactComponent };